import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserHistory } from 'history';
import React from 'react';
import { ModalStateProvider } from '../../hooks/modal/ModalStateProvider';
import ErrorBoundaryMain from './ErrorBoundaryMain';
import AccountDashboardRouter from './home/AccountDashboardRouter';

// Create our own custom history so we can programmatically navigate
// TypeScript doesn't know about the global window.shieldHistory, so we'll define it
declare global {
  interface Window {
    shieldHistory: any;
    Sentry: typeof Sentry;
  }
}

window.shieldHistory = createBrowserHistory({ basename: '/dashboard' });

window.Sentry = Sentry;
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://c03f6946d09147d1a64f6d7990cadba7@sentry.io/5175130',
    release: process.env.VERSION,
    environment: process.env.NODE_ENV,
  });
}

const queryClient = new QueryClient();

const AccountDashboard: React.FC = () => {

  return (
    <ErrorBoundaryMain>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <QueryClientProvider client={queryClient}>
          <ModalStateProvider>
            <AccountDashboardRouter />
          </ModalStateProvider>
        </QueryClientProvider>
      </LocalizationProvider>
    </ErrorBoundaryMain>
  );
};

export default AccountDashboard;